export enum DataFieldType {
    Key = 'key',
    String = 'string',
    Label = 'label',
    Number = 'number',
    Email = 'email',
    Slug = 'slug',
    SelectText = 'select-text',
    SelectNumber = 'select-number',
    SortNumber = 'sort-number',
    Currency = 'currency',
    Boolean = 'boolean',
    List = 'list',
    Date = 'date',
    Phone = 'phone',
    RadioList = 'radio-list',
    Image = 'image',
    Images = 'images',
    Videos = 'videos',
    Documents = 'documents',
    Editor = 'editor',
}
